import React, {useEffect, useRef,useState } from "react";
import { getEnvUrl,getToken } from "../../utils/Api";
import { deleteAssetByID } from "../../Services/Assets/assetsService";
import { toast } from 'react-toastify';
import CreateAssets from"./popups/createAssets"
import EditAssets from"./popups/editAssets"
import ViewAssets from"./popups/viewAssets"
import './quizAssets.css'; 
import { useNavigate } from "react-router-dom";  
const $ = require("jquery");
require("datatables.net");
const Assets = ({ data }) => {
  const navigate = useNavigate();
  const tableRef = useRef(null); 
  const [isLoading, setIsLoading] = useState(true);
  const [createAssetsModal, setCreateAssetsModal] = useState(false);
  const [editAssetsModal, setEditAssetsModal] = useState(false);
  const [viewAssetId, setViewAssetId] = useState(false);
  const [viewAssetName, setViewAssetName] = useState(false);
  const [editAssetName, setEditAssetName] = useState(false);
  const [viewAssetsModal, setViewAssetsModal] = useState(false);
  const [editAssetId, setEditAssetId] = useState(false);
  const [rerender, setRetender] = useState(true);
  const createAssetsModalClose=(rr=true)=>{
    setCreateAssetsModal(false)
    if(rr){
      setRetender(!rerender)
    } 
  }
  const editAssetsModalClose=(rr=true)=>{
    setEditAssetsModal(false) 
    if(rr){
      setRetender(!rerender)
    } 
  }  
   const viewAssetsModalClose=()=>{
    setViewAssetsModal(false)
    // setRetender(!rerender)
  } 
   
useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/assets/getAssetsDataTable`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        dataSrc: function (json) { 
          if(json.errorMessage!==undefined && (json.errorMessage==='Permission denied' || json.errorMessage === "Invalid token")){
           localStorage.clear();  
           navigate('/login')
          } else{
            return json.aaData
          } 
       }
      },
      columns: [
        { data: "id" },
        { data: "name" },
        { data: "asset" },
        { 
          data: null,
          title: 'Actions',
          render: (data, type, row) => `
            <div class="tooltip-container">
                  <span class="a-edit">
                      <i class="bi bi-pencil-square"></i>
                      <span class="tooltip-text">Edit</span>
                  </span>
              </div>
              <div class="tooltip-container">
                  <span class="a-view">
                      <i class="bi bi-eye-fill"></i>
                      <span class="tooltip-text">View</span>
                  </span>
              </div>
              <div class="tooltip-container">
                  <span class="a-delete">
                      <i class="bi bi-trash-fill"></i>
                      <span class="tooltip-text">Delete</span>
                  </span>
              </div>`
        },
      ],
      createdRow: (row, data, dataIndex) => {   
        $(row).find('.a-edit').on('click', () => { 
          setEditAssetsModal(true);
          setEditAssetId(data.id)
          setEditAssetName(data.name)
       });
       $(row).find('.a-view').on('click', () => { 
          setViewAssetsModal(true);
          setViewAssetId(data.id)
          setViewAssetName(data.name)
         });
         $(row).find('.a-delete').on('click', () => { 
          if(window.confirm('Are you sure you want to delete this asset?')){
            let inputData={
              asset_id:data.id
           }
        deleteAssetByID(inputData)
        .then((response) => {
       if (response?.status===true) {
          toast.success(response?.message)
          setRetender(!rerender)
       }
       })
       .catch((error) => {
       toast.error('Error deleting user:', error);
       });
          }
            
         });
      },
      'columnDefs': [ {
        'targets': [3], /* column index */
        'orderable': false, /* true or false */
     }],
      aaSorting: [[0, "desc"]],
      drawCallback: function(settings) {
        setIsLoading(false);
      },
    });

    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data, rerender,navigate]);

  
  return (
    <div> 
   <main id="main" className="main">
      <div className="pagetitle">
         <h1>Assets</h1>
      </div>
      <section className="section">
         <div className="row">
            <div className="col-lg-12">
               <div className="card p-10">
                  <div className="card-title">
                  <button type="button" className="btn btn-primary" 
                  onClick={()=>setCreateAssetsModal(true)} >Add Assets</button>
                  </div>
                    {isLoading && <div className="progress-bar"></div>}
                  <div className={isLoading?'card-body':'card-body'}>  
                  <table
                     className="table table-striped table-hover table-bordered no-footer dataTable"
                     width="100%"
                     ref={tableRef}
                     >
                     <thead>
                        <tr>
                           <th>Assets Id</th>
                           <th>Name</th>
                           <th>Asset</th>
                           <th>Actions</th>
                        </tr>
                     </thead>
                  </table>
            </div>
         </div>
         </div>
       </div>
      </section>
   </main>  
   {createAssetsModal?<CreateAssets isShow={createAssetsModal} close={createAssetsModalClose}  />:''} 
  {editAssetsModal?<EditAssets isShow={editAssetsModal} close={editAssetsModalClose} editAssetID={editAssetId} EditAssetName={editAssetName} />:''} 
  {viewAssetsModal?<ViewAssets isShow={viewAssetsModal} close={viewAssetsModalClose} viewAssetID={viewAssetId} ViewAssetName={viewAssetName} />:''} 
</div>
  );
};
export default Assets;



